<template>
  <div class="organization-shop-header">
    <!-- Banner/Cover Image -->
    <div class="cover-container">
      <v-img
        :src="'https://images.tcdn.com.br/img/img_prod/388802/1642013344_banner_festa_tropical_desktop.png'"
        height="240"
        class="cover-image"
      >
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular
              indeterminate
              color="grey lighten-5"
            ></v-progress-circular>
          </v-row>
        </template>

        <div class="overlay"></div>
      </v-img>

      <v-container class="profile-container">
        <div class="profile-content">
          <v-avatar size="120" class="profile-avatar">
            <v-img
              :src="'https://www.tocadavilla.com/wp-content/uploads/2021/01/SITE-4.jpg'"
              alt="Organization Logo"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <div class="profile-info">
            <h1 class="text-h4 font-weight-medium grey--text text--darken-2">
              {{ organization.name }}
            </h1>
            <div class="d-flex align-center mt-2">
              <v-chip
                v-if="organization.verified"
                color="primary"
                text-color="white"
                small
                outlined
                class="mr-2"
              >
                <v-icon left small>mdi-check-circle</v-icon>
                Verificado
              </v-chip>

              <div v-if="organization.social" class="social-links ml-2">
                <v-btn
                  v-if="organization.social.instagram"
                  icon
                  small
                  class="mr-1 grey--text text--darken-1"
                >
                  <v-icon>mdi-instagram</v-icon>
                </v-btn>
                <v-btn
                  v-if="organization.social.facebook"
                  icon
                  small
                  class="mr-1 grey--text text--darken-1"
                >
                  <v-icon>mdi-facebook</v-icon>
                </v-btn>
                <v-btn
                  v-if="organization.social.twitter"
                  icon
                  small
                  class="mr-1 grey--text text--darken-1"
                >
                  <v-icon>mdi-twitter</v-icon>
                </v-btn>
              </div>
            </div>
           
          </div>
        </div>
      </v-container>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrganizationShopHeader",
  props: {
    organization: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
};
</script>

<style scoped>
.organization-shop-header {
  margin-bottom: 20px;
}

.cover-container {
  position: relative;
}

.cover-image {
  width: 100%;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.1),
    rgba(0, 0, 0, 0.7)
  );
}

.profile-container {
  position: relative;
  z-index: 1;
  padding-bottom: 0;
  margin-top: -70px;
}

.profile-content {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  background: white;
  border-radius: 100px 36px 36px 100px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  padding-right: 24px;
  width: 100%;
  max-width: 100%;
}

.profile-avatar {
  border: 4px solid white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-left: -4px;
  z-index: 2;
}

.profile-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 16px 0 16px 16px;
}

.shop-tabs {
  margin-top: 20px;
}

.description-text {
  max-width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

@media (max-width: 600px) {
  .profile-content {
    flex-direction: column;
    align-items: center;
    border-radius: 26px;
    padding: 0 16px 16px;
  }

  .profile-avatar {
    margin-top: -60px;
    margin-left: 0;
  }

  .profile-info {
    text-align: center;
    align-items: center;
    padding-top: 8px;
  }
}
</style>
